var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKakaotalk = function SvgKakaotalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.548 3.992c-4.716 0-8.548 3.1-8.548 6.9 0 2.4 1.572 4.5 3.832 5.8l-.59 3.3 3.636-2.4c.491.1 1.08.1 1.572.1 4.716 0 8.548-3.1 8.548-6.9.098-3.7-3.733-6.8-8.45-6.8"
  })));
};
export default SvgKakaotalk;